import Vue from 'vue'
import Vuex from 'vuex'
import FormState from './modules/formState'
import Countries from './modules/countries'
import Telco from './modules/telco'
import Banks from './modules/banks'
import Message from './modules/message'
import Bill from './modules/bills'
import Transaction from './modules/transactions'
import Voucher from './modules/voucher'
import Notification from './modules/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        FormState,
        Countries,
        Telco,
        Banks,
        Message,
        Bill,
        Transaction,
        Voucher,
        Notification,
    },
})
